export const filter = (obj, fn) => {
  const result = {};
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    if (fn(obj[key], key, i)) {
      result[key] = obj[key];
    }
  }

  return result;
};

export const map = (obj, fn) => {
  const result = {};
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    result[key] = fn(obj[key], key, i);
  }

  return result;
};

export const fromArray = (array, key, fn, alt = null) => {
  const result = {};
  for (let i = 0; i < array.length; i += 1) {
    const item = array[i];
    const name = key(item, i);

    result[name] = fn(item, i);

    if (alt) Object.assign(result, alt(name, item));
  }

  return result;
};

export const fromJSON = (json, fallback) => {
  try {
    return JSON.parse(json);
  } catch (error) {
    return fallback ?? null;
  }
};

const minMax = (compare) => (collection) => {
  let result = null;
  const values = Object.values(collection ?? {});
  for (let i = 0; i < values.length; i += 1) {
    const item = values[i];
    if (result === null || compare(+item, +result)) {
      result = item;
    }
  }

  return result;
};

export const min = minMax((l, r) => l < r);
export const max = minMax((l, r) => l > r);

export const Choice = (target) => new Proxy(target, {
  get(base, key) {
    if (typeof base[key] === 'function') {
      return base[key].bind(this);
    }

    const choiceKey = key.toString().toUpperCase();
    if (!base[choiceKey]) {
      throw new Error(`Invalid choice ${choiceKey}`);
    }

    return base[choiceKey];
  },
});
